import React, { memo, useState, useEffect, useCallback, useMemo } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getProductReviewListReset } from '../../../../actionCreators/review';
import InfoModalComponent from './../../../components/Common/InfoModalComponent';
import ProductDetailNew from '../ProductDetailNew';
import sessionStorageHelper from './../../../../utils/sessionStorageHelper';
import { odPushGA4Event } from './../../../../utils/gaFour';
import { odPushTTQEvent } from '../../../../utils/tiktokPixel';
import { setToastMessage, shortlist } from '../../../../actionCreators/common';
import { isEmptyObject } from './../../../../utils/helper';
import './SideBarOwnDays.scss';
import '../../../../own-days/CommonComponents/OdButton/OdButton.scss';
import SideBarFooter from './SideBarFooter/SideBarFooter';
import { addToCart } from '../../../../actionCreators/cart';
import AuthModalNewLoadable from '../../AuthModalNew/AuthModalNewLoadable.js';
import { v4 } from 'uuid';
import { isGundamCollection } from '../../../../own-days/views/desktop/Gundam/gundamHelper.jsx';
import SelectLenses from '../../../../own-days/CommonComponents/SelectLensesModal/SelectLenses.jsx';
import { toggleLensesSelectionPopup } from '../../../../actionCreators/product.js';
import {
  callClevertapEventWithCallback,
  getCtaLabel,
  sunglassOrAccessories,
  replaceImageURL,
} from '../../../../own-days/helper.js';
import CompatibleLenses from './../../../../own-days/CompatibleLenses/CompatibleLenses';
import TechnicalDetails from './../../../../own-days/TechnicalDetails/TechnicalDetails';
import PDPContactLensFeatures from '../../../../own-days/Desktop/PDPContactLensFeatures/PDPContactLensFeatures';
import { isAccessories } from '../../../containers/Product/productHelper.js';
import SizeGuide from '../../../../own-days/SizeGuide/SizeGuide.jsx';
import StoreBenefit from '../../../../own-days/StoreBenefit/StoreBenefit.jsx';

export const SideBarOD = props => {
  const {
    localeInfo,
    productData,
    showFAQTab,
    shortListData,
    currencyMark,
    modifiedProductData,
    productId,
    setWishList,
    productApiCall,
    productPriceWithGst,
    frameType,
    triggerFbEventOnClick,
    frameShape,
    frameSize,
    dataLocale,
    redisCommonData,
    shortListLoading,
    history,
    login,
    userInfo,
    isYotpoWidgets,
    commonApiCall,
    wishlistCount,
    setToastMessage,
    platform,
    contactLensPowerFromUrl,
    setColorPreviewImageUrl,
    contactLensPackaging,
    contactLensPowers,
    isLensesSelectionPopupOpen,
    toggleLensesSelectionPopup,
    // exchangePrice,
  } = props;

  const register = useSelector(state => state.auth.register);
  const isCartDataLoaded = useSelector(state => state?.cart?.isCartDataLoaded);
  const cartError = useSelector(state => state?.cart?.cartError);
  const [addingToCart, setAddingToCart] = useState(false);

  const [shortlistFull, setShortlistFull] = useState(false);
  const [isScrollDown, setIsScrollDown] = useState(false);
  const [slMessage, setSlMessage] = useState({});
  const [showAuthPopUp, setShowAuthPopUp] = useState(false);
  const [registeredSuccessfully, setRegisteredSuccessfully] = useState(false);
  const [selectedContactLensPowers, setSelectedContactLensPowers] = useState({
    left: {},
    right: {},
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (addingToCart) {
      if ((isCartDataLoaded, !cartError)) {
        callClevertapEventWithCallback(
          'Added to Cart',
          {
            productData,
            prescriptionType: null,
          },
          () => {
            history.push('/cart');
          }
        );
        setAddingToCart(false);
      }

      if (cartError) {
        dispatch(setToastMessage({ message: cartError?.message, timeout: 5000, warning: true }));
      }
    }
  }, [addingToCart, isCartDataLoaded, cartError]);

  // https://api-gateway.juno.preprod.lenskart.com/v2/products/product/304002/powers?contact_lens=

  const isExchange =
    (sessionStorageHelper.getItem('exchangeMethod') === 'NEWPRODUCT' &&
      sessionStorageHelper.getItem('exchangeNP') === true) ||
    null;

  const { EXCHANGE_CONFIG } = redisCommonData;
  const {
    YOU_CAN_SHORTLIST_UPTO_50,
    SHORTLIST_LIMIT_REACHED,
    SELECT_LENS_CTA,
    ADD_TO_CART,
    CONTACT_LENS_POWER_INVALID,
    SOLD_OUT,
  } = dataLocale;

  const displayPrice = modifiedProductData?.firstFrameFree
    ? modifiedProductData?.firstFrameFreePrice
    : modifiedProductData?.lenskartPrice;
  let exchangeFreeText;
  let exchangeText;
  if (isExchange && EXCHANGE_CONFIG) {
    const exchangeConfig = JSON.parse(redisCommonData.EXCHANGE_CONFIG);
    exchangeFreeText = exchangeConfig && exchangeConfig.EXCHANGE_FREE_TEXT;
    exchangeText = exchangeConfig && exchangeConfig.EXCHANGE_TEXT;
  }

  const isNewAuthPopUpAvailable = !!(
    redisCommonData?.NEW_AUTH_POPUP_DESKTOP &&
    JSON.parse(redisCommonData?.NEW_AUTH_POPUP_DESKTOP)?.enable === 'ON'
  );

  const isShortListErrWinClosed = () => {
    setShortlistFull(false);
  };

  const isYotpoWidgetsShow = () => {
    if (!isYotpoWidgets) {
      commonApiCall.setYotpoWidgetsState({ isYotpoWidgets: true });
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (!isScrollDown && window.pageYOffset > 20) setIsScrollDown(true);
    });

    return () => {
      getProductReviewListReset();
    };
  }, [isScrollDown]);

  const callBackForInfoModal = () => {
    isShortListErrWinClosed();
  };

  const shortListProduct = shortListData?.result?.productIds.concat(
    shortListData.result.productList.map(({ id }) => id)
  );
  const isShortlisted = shortListProduct?.indexOf(productData.id) > -1;

  const hideAuthPopUp = useCallback(() => {
    clearInterval(window.secondsTimer);
    if (register) {
      setRegisteredSuccessfully(true);
    } else {
      setShowAuthPopUp(false);
    }
  }, [register]);

  useEffect(() => {
    if (registeredSuccessfully) {
      const timer = setTimeout(() => {
        setShowAuthPopUp(false);
      }, 3000);

      return () => clearTimeout(timer);
    }

    return () => {};
  }, [registeredSuccessfully]);

  useEffect(() => {
    if (!isEmptyObject(slMessage) && wishlistCount !== 50) {
      setToastMessage(slMessage);
    }
  }, [setToastMessage, slMessage, wishlistCount]);

  const handleAddToCartCTA = () => {
    odPushGA4Event('cta_click', {
      userInfo,
      platform,
      ctaName: 'add-to-cart',
      ctaFlowAndPage: 'product-detail-page',
    });

    if (sunglassOrAccessories(productData?.classification)) {
      const gaPLPSelectItemData =
        JSON.parse(sessionStorage.getItem('ga-plp-select-item-data')) || {};
      const gaAddToCartData = JSON.parse(sessionStorage.getItem('ga-add-to-cart-data')) || {};

      odPushGA4Event('add_to_cart', {
        userInfo,
        productData,
        gaPLPSelectItemData,
        gaAddToCartData,
      });

      odPushTTQEvent('AddToCart', {
        userInfo,
        productData,
      });
      // OD_NOT_REQ: _____Not Required for OWNDAYS as of now return check on login if required__________
      // if (login) {
      //   dispatch(addToCart({ productId, powerType: 'Frame Only' }));
      //   history.push('/cart');
      // } else displayAuthPopUp();
      if (isGundamCollection(productId)) {
        dispatch(addToCart({ productId }));
      } else {
        dispatch(addToCart({ productId, powerType: 'Frame Only' }));
      }
      setAddingToCart(true);
    } else if (productData?.classification === 'contact_lens') {
      const gaPLPSelectItemData =
        JSON.parse(sessionStorage.getItem('ga-plp-select-item-data')) || {};
      const gaAddToCartData = JSON.parse(sessionStorage.getItem('ga-add-to-cart-data')) || {};

      odPushGA4Event('add_to_cart', {
        userInfo,
        productData,
        gaPLPSelectItemData,
        gaAddToCartData,
      });

      odPushTTQEvent('AddToCart', {
        userInfo,
        productData,
      });

      console.log('add to cart', {
        productId,
        powerType: 'CONTACT_LENS',
        ...selectedContactLensPowers,
      });

      if (
        selectedContactLensPowers.left?.boxes &&
        selectedContactLensPowers.left?.sph >= 0 &&
        selectedContactLensPowers.right?.boxes &&
        selectedContactLensPowers.right?.sph >= 0
      ) {
        dispatch(
          addToCart({
            productId,
            powerType: 'CONTACT_LENS',
            prescription: { ...selectedContactLensPowers },
          })
        );
        setAddingToCart(true);
      }
    } else {
      toggleLensesSelectionPopup(true);
      // history.push(`/select-lenses/${productData.id}`);
    }
  };

  const selectContactLensPowersCallback = (eye, type, value) => {
    setSelectedContactLensPowers({
      ...selectedContactLensPowers,
      [eye]: {
        ...selectedContactLensPowers[eye],
        [type]: value,
      },
    });

    console.log('selectedContactLensPowers', selectedContactLensPowers);
  };

  const addToCartErrors = useMemo(() => {
    if (
      productData.classification === 'contact_lens' &&
      !contactLensPowers?.every(
        ({ type }) => selectedContactLensPowers.left[type] && selectedContactLensPowers.right[type]
      )
    )
      return [CONTACT_LENS_POWER_INVALID];

    return null;
  }, [productData, selectedContactLensPowers]);

  const handleLensesModal = value => {
    toggleLensesSelectionPopup(value);
  };

  const isAccessoriesFlagDesktop = isAccessories(productData);

  return (
    <div className="product-sidebar" onFocus={isYotpoWidgetsShow} onMouseOver={isYotpoWidgetsShow}>
      <div className="product-sidebar__card">
        {isLensesSelectionPopupOpen && (
          <div style={{ position: 'absolute', zIndex: '15' }}>
            <SelectLenses handleModal={handleLensesModal} productData={productData} />
          </div>
        )}
        {shortlistFull && (
          <InfoModalComponent
            callback={callBackForInfoModal}
            headerTitle={SHORTLIST_LIMIT_REACHED}
            msgContent={YOU_CAN_SHORTLIST_UPTO_50}
            msgType="info"
          />
        )}
        <ProductDetailNew
          contactLensPackaging={contactLensPackaging}
          contactLensPowerFromUrl={contactLensPowerFromUrl}
          contactLensPowers={contactLensPowers}
          currencyMark={currencyMark}
          dataLocale={dataLocale}
          displayPrice={displayPrice}
          exchangeFreeText={exchangeFreeText}
          exchangeText={exchangeText}
          frameShape={frameShape}
          frameSize={frameSize}
          frameType={frameType}
          history={history}
          isExchange={isExchange}
          localeInfo={localeInfo}
          login={login}
          productApiCall={productApiCall}
          productData={productData}
          productId={productId}
          productPriceWithGst={productPriceWithGst}
          redisCommonData={redisCommonData}
          selectContactLensPowersCallback={selectContactLensPowersCallback}
          setColorPreviewImageUrl={setColorPreviewImageUrl}
          setShortlistFull={setShortlistFull}
          setWishList={setWishList}
          shortListData={shortListData}
          shortListLoading={shortListLoading}
          showFAQTab={showFAQTab}
          triggerFbEventOnClick={triggerFbEventOnClick}
          userInfo={userInfo}
        />
        <div className="sidebar__btn-atc">
          {addToCartErrors?.map(error => (
            <div key={v4()} className="sidebar__invalid od-font-reg">
              {error}
            </div>
          ))}
          <button
            className="odButton odButton--fluid"
            disabled={!!addToCartErrors || productData?.qty === 0}
            onClick={handleAddToCartCTA}
          >
            {getCtaLabel(productData?.qty, productData?.classification)}
          </button>
        </div>
        <SideBarFooter
          isShortlisted={isShortlisted}
          productData={productData}
          setSlMessage={setSlMessage}
          wishlistCount={wishlistCount}
        />
      </div>
      {productData?.classification !== 'accessories_revenue' &&
        (productData?.classification === 'contact_lens' ? (
          <PDPContactLensFeatures productData={productData} />
        ) : (
          <>
            <div className="product-sidebar__card">
              <TechnicalDetails
                isAccessories={isAccessoriesFlagDesktop}
                productColorCode={productData?.colorCode}
                productId={productData?.id}
                specifications={productData?.specifications}
                thumbnailImage={
                  productData?.imageUrlsDetail?.[1]?.url
                    ? replaceImageURL(
                        productData?.imageUrlsDetail?.[1]?.url,
                        localeInfo,
                        productData?.id
                      )
                    : productData?.thumbnailImage
                }
              />
            </div>
            <div className="product-sidebar__card">
              <SizeGuide />
              <CompatibleLenses isAccessories={isAccessoriesFlagDesktop} />
            </div>
          </>
        ))}
      <div className="product-sidebar__card">
        <StoreBenefit />
      </div>
      {showAuthPopUp && isNewAuthPopUpAvailable && (
        <AuthModalNewLoadable
          allowSignUp
          hideLogin={hideAuthPopUp}
          hideSuccessModal={() => setShowAuthPopUp(false)}
          login={login}
          openTab={registeredSuccessfully ? 'successSignUp' : 'signin'}
        />
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  shortListData: state.common.shortListData,
  dataLocale: state.locale,
  currencyMark: state.common.currencyMark,
  redisCommonData: state.common.redisCommonData,
  modifiedProductData: state.product.modifiedProductData,
  shortListLoading: state.common.shortListLoading,
  login: state.common.login,
  userInfo: state.common.userInfo,
  localeInfo: state.common.localeInfo,
  platform: state.DTM.platform,
  wishlistCount: state.common.isWishlistCount,
  isLensesSelectionPopupOpen: state.product.isLensesSelectionPopupOpen,
});

function mapDispatchToProps(dispatch) {
  return {
    getProductReviewListReset: bindActionCreators(getProductReviewListReset, dispatch),
    setToastMessage: data => dispatch(setToastMessage(data)),
    toggleLensesSelectionPopup: data => dispatch(toggleLensesSelectionPopup(data)),
    shortlist: (productId, method, suffixUrl) => dispatch(shortlist(productId, method, suffixUrl)),
  };
}

const SideBarOwnDays = connect(mapStateToProps, mapDispatchToProps)(memo(SideBarOD));
export default SideBarOwnDays;
